import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcenter"},[_c(VIcon,{staticClass:"mr-2",attrs:{"small":"","color":_vm.color},on:{"click":_vm.goto_qunit}},[_vm._v("\n    mdi-arrow-right\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }